import UserPreferences from '../../domain/UserPreferences';

const mapUserPreferencesDtoToDomain = dto =>
  UserPreferences.create({
    highContrastMode: Boolean(dto?.high_contrast_mode),
  });

const mapUserPreferencesDomainToDto = userPreferences => ({
  high_contrast_mode: userPreferences.highContrastMode,
});

export { mapUserPreferencesDomainToDto, mapUserPreferencesDtoToDomain };
